<template>
  <div class="invoice-description-subject">
    <h3 class="invoice-description-subject-title">
      Subject
    </h3>
    <p class="invoice-description-subject-text">
      {{ subject }}
    </p>
  </div>
</template>

<script>
export default {
  name: "InvoiceSubject",

  props: {
    subject: { type: String }
  }
}
</script>
